// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import battleMode from "../battleMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class did extends cc.Component {

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

    }

    bindData(game: battleMode) {
        const com = this.node.getComponent(cc.Animation);
        com.on('finished', () => {
            game.destroyDid(this.node);
        });
        com.play();
    }

    // update (dt) {}
}
